import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../booking/redux/actions';
import { Card, Icon, Col, Row, Button, Tooltip, Badge } from 'antd';
import moment from 'moment';
import { is, STATUS, description as cut, isRestricted, restrictedLevel, toTag } from '../admin/events/Constants';
import { IMAGES_URL } from '../../helper/api/Api';
import { url } from '../../helper/image';
import BadgeHelper from './Badge'
const { Meta } = Card;

export class CardEvent extends Component {

  static propTypes = {
    event: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    if(!this.props.item) return null;

    const description = cut(this.props.item.description, 85);
    const openAt = moment(this.props.item.openAt, "YYYY-MM-DD HH:mm", 'fr');
    //const closeAt = moment(this.props.item.closeAt, "YYYY-MM-DD HH:mm", 'fr');
    //const startAt = moment(this.props.item.startAt, "YYYY-MM-DD HH:mm", 'fr');
    //const endAt = moment(this.props.item.endAt, "YYYY-MM-DD HH:mm", 'fr');
    const subscribeNumber = this.props.item.subscribeNumber;
    const subscribedNumber = this.props.item.subscribedNumber;
    const isSubscribe = is(this.props.item, true) === STATUS.ONGOING;
    const availableSeat = subscribeNumber - subscribedNumber;

    const bodyitem = (
      <div className="height-item">
        <Row>
          <Col style={{height: 64}}>
            <Icon type="align-left" theme="outlined" />
            { description && <span dangerouslySetInnerHTML={{__html: description}}></span> }
          </Col>
          {/*<Col>
            <Icon type="team" theme="outlined" />
            {availableSeat}
            {availableSeat > 1 ? (
              <span> places disponibles</span>
            ) : (
              <span> place disponible</span>
            )}
          </Col>*/}
          <Col style={{ color: this.props.showPresence ? "#000" : toTag(is(this.props.item, true)).color }}>
            <Icon type="form" theme="outlined" />{
              this.props.showPresence ? 
                `${subscribedNumber} inscrit(s)` :
                [STATUS.FULL_FREE].includes(is(this.props.item, true)) ? "" : "Inscriptions :"
              } {!this.props.showPresence  && toTag(is(this.props.item, true)).text.toLowerCase()}
          </Col>
        </Row>
      </div>
    )

    const firstImage = <img src={IMAGES_URL(this.props.item.images)} />;
    const restrictedRole = restrictedLevel(this.props.item);
    const placeLeft = subscribeNumber - subscribedNumber;


    return (
      <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 12 }} lg={{ span: 8 }} xl={{ span: 6 }} className="event-item">
        <Card
          className={isSubscribe ? "card-events card-events-inscriptions" : "card-events"}
          hoverable={true}
          cover={firstImage}
          actions={[
            <div>
              <Button className="ui-btn" onClick={() => this.props.showPresence ? this.props.showPresence(this.props.item) : this.props.showModal(true, this.props.item.id)} >
                { this.props.showPresence ? "Gérer les présences" : "Détails de l'événement" }
              </Button>
            </div>]}
        >
          <Meta
            title={<BadgeHelper event={this.props.item} />}
            description={bodyitem}

          />
          <div className="bookmark"
            style={{ backgroundImage: "url(" + url("bookmark.png") + ")" }}>
            <p className="day">{openAt.format('DD')}</p>
            <p className="month">{openAt.format('MMMM').substring(0, 3)}</p>
          </div>
          {!this.props.showPresence && subscribedNumber > 0 ? 
            <div className="badge-user">
              <Badge
                title={isSubscribe ? "Nombre de places" : "Participants" }
                count={
                    isSubscribe ? 
                      (subscribeNumber > 99 ? 
                        <div style={{display: 'flex',flexDirection: 'column', justifyContent: 'center', lineHeight: "13px"}}><div style={{marginTop: 4}}>{subscribedNumber}</div> <div className="subscribeNumberTotal">/{subscribeNumber}</div></div>
                      : <div> {subscribedNumber} { subscribeNumber ? <span className="subscribeNumberTotal"> / {subscribeNumber}</span>: ''}</div>)
                      : 
                      (subscribedNumber > 99 ? <div>{subscribedNumber}</div>
                        : subscribedNumber
                      ) 
                    } 
                style={{ backgroundColor: '#fff', color: '#999', top: ( isSubscribe && subscribeNumber > 99 ? -8 : 0) , right: -23, boxShadow: '0 0 0 1px #d9d9d9 inset', height: ( isSubscribe && subscribeNumber > 99 ? 35 : null)}} >
                <Icon type="team" theme="outlined" />
              </Badge>
            </div>
          : ''}
          {!this.props.showPresence && isSubscribe && placeLeft > 0 && ( placeLeft < 3 || (100 * subscribedNumber / subscribeNumber) > 90 ) ?
            <div className="place-left">
              { placeLeft } place{placeLeft === 1 ? "": "s"} restante{placeLeft === 1 ? "": "s"} !
            </div>
            : ""
          }

          {/* ÉVÉNEMENTS SEULEMENT POUR YNOV */}
          {
            isRestricted(this.props.item) &&
            <Tooltip placement="top" title={restrictedRole.name}>
              <div className="ribbon-wrapper">
                <div className={"ribbon " + restrictedRole.class}>{restrictedRole.title}</div>
              </div>
            </Tooltip> 
          }
        </Card>
      </Col>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    event: state.event,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CardEvent);



// WEBPACK FOOTER //
// ./src/features/event/CardEvent.js